export const OPERASYON = {
  title: 'Operasyon', eyebrow: 'GÜNLÜK ÇALIŞMA ALANI',
  intro: 'Öncelikleri görün, sıradaki işi tamamlayın.',
  overview: 'İş kuyruğu', calendar: 'Operasyon takvimi', documents: 'Belgeler',
  orders: 'Sipariş işlemleri', visa: 'Vize talepleri', transfer: 'Transfer',
  newDocument: 'Belge oluştur', turPdf: 'PDF Düzenle', tools: 'Diğer işlemler',
  cancellations: 'Tedarikçi iptalleri', notifications: 'Tedarikçi bildirimleri',
  cost: 'Tedarikçi maliyeti', completion: 'Hizmet tamamlama',
  refresh: 'Yenile', updated: 'Son güncelleme', loading: 'İşler yükleniyor…',
  loadError: 'İş kuyruğu yüklenemedi. Yeniden deneyin.',
  pending: 'Bekleyen iş', late: 'Uzun süredir bekleyen', blocked: 'Engellenen iş',
  visaWaiting: 'Vize takibi', pendingNote: 'Ana iş kuyruklarının toplamı',
  lateNote: (hours: number) => `${hours} saatin üzerinde bekliyor`,
  blockedNote: 'İlerlemeden önce çözüm gerekiyor', visaNote: 'Gönderim ve sonuç bekleyen',
  queueTitle: 'Öncelikli işler', queueIntro: 'Tüm iş türleri, tek çalışma listesinde.',
  all: 'Tüm işler', visaType: 'Vize', tasks: 'Operasyon', web: 'Web siparişleri',
  search: 'İş kuyruğunda ara', searchPlaceholder: 'Sipariş, yolcu veya hizmet ara…',
  sort: 'Sıralama', oldest: 'En uzun bekleyen', newest: 'En yeni',
  age: 'Bekleme süresi', anyAge: 'Tüm süreler', lateOnly: '48 saat ve üzeri',
  job: 'Sipariş / hizmet', customer: 'Yolcu / açıklama', status: 'Durum', action: 'İşlem',
  inspect: 'İncele', close: 'Kapat', details: 'İş ayrıntıları', open: 'İşleme geç',
  noItems: 'Bekleyen iş bulunmuyor', noItemsHint: 'Yeni işler geldiğinde bu alanda görünecek.',
  noMatches: 'Aramanıza uygun iş yok', noMatchesHint: 'Aramayı veya filtreleri değiştirin.',
  clear: 'Filtreleri temizle', unknown: 'Belirtilmemiş', unmeasured: 'Ölçülmüyor',
  hours: (n: number) => `${new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 1 }).format(n)} sa`,
  results: (n: number, total: number) => `${n} iş gösteriliyor · Kuyruk toplamı ${total}`,
  limited: 'Liste sınırlı bir kesit içeriyor. Arama ve sıralama yüklenen kayıtlar üzerinde çalışır.',
  otherQueues: 'Diğer bekleyen işler', systems: 'Bağlantı ve sistem durumu',
  focusTitle: 'Bekleme özeti', focusIntro: 'Ana kuyruklardaki işlerin dağılımı',
  under24: '24 saatten az', between: '24–48 saat', over48: '48 saatten fazla',
  shortcutTitle: 'Hızlı erişim', shortcutHint: 'Sık kullanılan operasyon işlemleri',
  docHint: 'Otel, uçuş ve vize destek belgeleri', calendarHint: 'Tarihli hizmetleri planlayın',
  visaHint: 'Başvuruyu gönderin, sonucu takip edin',
  queued: 'Gönderim bekliyor', submitted: 'Sonuç bekliyor', taskPending: 'Başlanmamış',
  taskBlocked: 'Engellenmiş', webPending: 'İşleme hazır',
  demo: 'Tasarım önizlemesi · Tüm kayıtlar örnektir',
  demoHint: 'Bu önizlemede yapılan seçimler gerçek kayıtları değiştirmez.',
  demoPopulated: 'Örnek işler', demoEmpty: 'Boş durum', demoError: 'Hata durumu',
  preview: 'Yerel önizleme', demoUser: 'Operasyon ekibi',
  nav: ['Genel Bakış', 'Müşteriler', 'Satış', 'Operasyon', 'Pazarlama', 'Finans', 'İK', 'Denetim'],
  breadcrumb: 'Çalışma alanı', back: 'İş kuyruğuna dön',
} as const;
